export default __webpack_public_path__ + "static/media/frontEnd.17aadbad.png";